const longModeRatio = 3;

function getRotateSize(rotate, width, height) {
  const isVertical = rotate % 180 !== 0;

  // 若图片不是水平则调换属性
  if (isVertical) {
    return [height, width, isVertical];
  }

  return [width, height, isVertical];
}

export default function getSuitableImageSize(naturalWidth, naturalHeight) {
  const [currentWidth, currentHeight, isVertical] = getRotateSize(0, window?.innerWidth, window?.innerHeight);

  let y = 0;
  let width = currentWidth;
  let height = currentHeight;

	
  // 自适应宽高
  const autoWidth = (naturalWidth / naturalHeight) * currentHeight;
  const autoHeight = (naturalHeight / naturalWidth) * currentWidth;

  if (naturalWidth < currentWidth && naturalHeight < currentHeight) {
    width = naturalWidth;
    height = naturalHeight;
  } else if (naturalWidth < currentWidth && naturalHeight >= currentHeight) {
    width = autoWidth;
  } else if (naturalWidth >= currentWidth && naturalHeight < currentHeight) {
    height = autoHeight;
  } else if (naturalWidth / naturalHeight > currentWidth / currentHeight) {
    height = autoHeight;
  }
  // 长图模式
  else if (naturalHeight / naturalWidth >= longModeRatio && !isVertical) {
    height = autoHeight;
    y = (height - currentHeight) / 2;
  } else {
    width = autoWidth;
  }
  return {
    width,
    height,
    x: 0,
    y,
    pause: true,
  };
}
